import React from 'react';
import { Link } from 'react-router-dom';
import Icon from 'components/AppIcon';
import Image from 'components/AppImage';

const HeroSection = ({ currentLanguage }) => {
  const content = {
    es: {
      title: "Servicio Profesional de Limpieza de Piscinas en Costa Rica",
      subtitle: "Mantenemos tu piscina cristalina y lista para disfrutar todo el año",
      features: [
        "Servicio semanal garantizado",
        "Productos químicos incluidos",
        "Técnicos certificados"
      ],
      ctaButton: "Solicitar Cotización",
      emergencyText: "Servicio de emergencia 24/7"
    },
    en: {
      title: "Professional Pool Cleaning Service in Costa Rica",
      subtitle: "We keep your pool crystal clear and ready to enjoy all year round",
      features: [
        "Guaranteed weekly service",
        "Chemicals included",
        "Certified technicians"
      ],
      ctaButton: "Get Quote",
      emergencyText: "24/7 emergency service"
    }
  };

  const text = content[currentLanguage];

  return (
    <section className="relative min-h-screen flex items-center justify-center overflow-hidden">
      {/* Background Image */}
      <div className="absolute inset-0 z-0">
        <Image
          src="https://images.pexels.com/photos/261102/pexels-photo-261102.jpeg?auto=compress&cs=tinysrgb&w=2000"
          alt="Beautiful swimming pool"
          className="w-full h-full object-cover"
        />
        <div className="absolute inset-0 bg-black/40"></div>
      </div>

      {/* Content */}
      <div className="relative z-10 max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center text-white">
        <div className="max-w-4xl mx-auto">
          <h1 className="text-4xl md:text-6xl font-heading font-bold mb-6 leading-tight">
            {text.title}
          </h1>
          
          <p className="text-xl md:text-2xl mb-8 text-white/90 max-w-3xl mx-auto">
            {text.subtitle}
          </p>

          {/* Features */}
          <div className="flex flex-wrap justify-center gap-6 mb-10">
            {text.features.map((feature, index) => (
              <div key={index} className="flex items-center space-x-2 bg-white/10 backdrop-blur-sm px-4 py-2 rounded-full">
                <Icon name="CheckCircle" size={20} className="text-accent" />
                <span className="text-sm font-medium">{feature}</span>
              </div>
            ))}
          </div>

          {/* CTA Buttons */}
          <div className="flex flex-col sm:flex-row gap-4 justify-center items-center mb-8">
            <Link
              to="/contact-quote-request"
              className="bg-accent text-white px-8 py-4 rounded-lg font-semibold text-lg hover:bg-accent/90 nav-transition shadow-large"
            >
              {text.ctaButton}
            </Link>
            
            <a
              href="tel:+50622534791"
              className="flex items-center space-x-2 bg-white/10 backdrop-blur-sm text-white px-6 py-4 rounded-lg font-medium hover:bg-white/20 nav-transition"
            >
              <Icon name="Phone" size={20} />
              <span>+506 2253-4791</span>
            </a>
          </div>

          {/* Emergency Service */}
          <div className="flex items-center justify-center space-x-2 text-sm text-white/80">
            <Icon name="Clock" size={16} className="text-warning" />
            <span>{text.emergencyText}</span>
          </div>
        </div>
      </div>

      {/* Scroll Indicator */}
      <div className="absolute bottom-8 left-1/2 transform -translate-x-1/2 animate-bounce">
        <Icon name="ChevronDown" size={24} className="text-white/60" />
      </div>
    </section>
  );
};

export default HeroSection;